<template>
  <div id="administrador">
    <!-- <div class="separador text-center mt-5 py-5" data-aos="fade-up" data-aos-delay="600">
      <p class="otrafont fXG electrico">Cuestionarios Registrados</p>
    </div> -->

    <HeaderAdmin></HeaderAdmin>

    <div class="pt4">
      <!-- <div class="row pb-5">
        <div class="col-12 otrafont fpR electrico">Semana 1</div>
      </div>-->

      <!-- <b-sidebar id="sidebar-1" title="Menú" shadow>
        <div class="px-3 py-2">
          <a class="float-right fpR pointer" @click="logout"> Cerrar Sesión </a>
        </div>
      </b-sidebar> -->

      <div class="row m-0">
        <div class="col-3">
          <div class="row">
            <div class="col-12">
              <SidebarAdmin></SidebarAdmin>
            </div>
          </div>
        </div>

        <div class="col-9 bgazuladmin bgazulgradiente p-5">
          <div class="row p-5" data-aos="fade-left" data-aos-delay="200">
            <div class="col-12 pb-5">
              <h2 class="blanco bold pb-3 fpG">Interpretación de resultados</h2>
              <p class="fpG blanco">
                En esta sección puedes encontrar documentación que te ayudará a
                entender e interpretar los resultados de cada nivel.
              </p>
            </div>
            <div class="col-12 py-5">
              <div class="row">
                <div class="col-lg-4 text-center pb-4">
                  <a href="https://encaucetotal.com/2021/05/11/estilo-de-aprendizaje-modelo-de-kolb/" target="_blank" class="nounderline d-block bg-white rounded shadow ">
                    <div class="electrico fpG py-2">
                      Nivel 1
                    </div>
                    <img
                      src="../../assets/imgs/progreso/planeta-1.png"
                      alt="Planeta"
                      class="planeta pointer py-3  img-fluid"
                    />
                  </a>
                </div>
                <div class="col-lg-4 text-center pb-4">
                  <a href="https://encaucetotal.com/2021/05/10/el-modelo-de-los-cuadrantes-cerebrales-de-herrmann/" target="_blank" class="nounderline d-block bg-white rounded shadow ">
                    <div class="electrico fpG py-2">
                      Nivel 2
                    </div>
                    <img
                      src="../../assets/imgs/progreso/planeta-2.png"
                      alt="Planeta"
                      class="planeta pointer py-3 img-fluid"
                    />
                  </a>
                </div>
                <div class="col-lg-4 text-center pb-4">
                  <a href="https://encaucetotal.com/2021/05/07/objetivos-de-desarrollo-sostenible-2/" target="_blank" class="nounderline d-block bg-white rounded shadow ">
                    <div class="electrico fpG py-2">
                      Nivel 4 y 5
                    </div>
                    <img
                      src="../../assets/imgs/progreso/planeta-3.png"
                      alt="Planeta"
                      class="planeta pointer py-3 img-fluid"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Glyphicons></Glyphicons>
  </div>
</template>


<script>
import Glyphicons from "@/views/Glyphicons";
import AOS from "aos";
import swal from "sweetalert2";

import SidebarAdmin from "@/components/SidebarAdmin";
import HeaderAdmin from "@/components/HeaderAdmin";

import * as fb from "../../firebase";
import * as moment from "moment";
import { misionesCollection, usersCollection } from "@/firebase";
import Vue from "vue";

import { ServerTable, ClientTable, Event } from "vue-tables-2";
Vue.use(ClientTable);

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

export default {
  components: {
    SidebarAdmin,
    HeaderAdmin,
    Glyphicons,
  },
  data() {
    return {
      file: null,
      csv: null,
      formDisponibles: {
        disponibles: 100,
      },
      form: {
        id_usuario: "",
        nombre: "",
        apellidos: "",
        email: "",
        plantel: "",
        grupo: "",
      },
      formCargar: {
        file: "",
      },
      formFacturacion: {
        rfc: "",
        nombre: "",
        email: "",
        telefono: "",
        direccion: "",
      },
      columns: ["nombre", "apellidos", "email", "plantel", "grupo"],
      data: null,
      options: {
        perPage: 100,
        headings: {
          id_usuario: "ID Usuario",
          nombre: "Nombre",
          apellidos: "Apellidos",
          email: "Email",
          plantel: "Plantel",
          grupo: "Grupo",
        },
        editableColumns: [],
        sortable: [],
        texts: {
          count:
            "Mostrando {from} hasta {to} de {count} registros|{count} registros|Un registro",
          first: "Primero",
          last: "Último",
          filter: "Filtro:",
          filterPlaceholder: "Búsqueda",
          limit: "Registros:",
          page: "Página:",
          noResults: "No hay datos.",
          noRequest: "Por favor selecciona una opción para filtrar resultados",
          filterBy: "Filtrar por {column}",
          loading: "Cargando...",
          defaultOption: "Seleccionar {column}",
          columns: "Columnas",
        },
      },
      grupos: [],
      planteles: [],
      estudiantes: [],
    };
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });

    this.camposObj = this.$store.state.campos_conocimiento;
    this.planteles = this.$store.state.admin.planteles;
    this.grupos = this.$store.state.admin.grupos;
    this.estudiantes = this.$store.state.admin.estudiantes;
  },
  methods: {
    confirmarCarga() {
      this.csv.forEach((estudiante) => {
        this.estudiantes.push(estudiante);
      });
      this.csv = null;
      this.$store.state.admin.estudiantes = this.estudiantes;
    },
    submitCarga() {
      console.log({ csv: this.csv });
    },
    fileSelected: function ($event) {
      console.log($event);

      this.file = $event.target.files[0];

      var reader = new FileReader();

      reader.onload = function (e) {
        // get loaded data and render thumbnail.

        console.log(e.target.result);
      };

      // read the image file as a data URL.
      reader.readAsDataURL(this.file);
    },
    submitForm(e) {
      e.preventDefault();

      this.estudiantes.push(this.form);
      this.$store.state.admin.estudiantes = this.estudiantes;

      //this.$store.dispatch("setDatosAdministrador", this.form);
    },
  },
};
</script>
